export interface IWorkRelationWithTimesheet {
  timesheet: { paidMinutesSum: number } | null;
}

// Worked minutes (after breaks) registered on the work relation's timesheet
// for the month it was fetched for; 0 when there is no timesheet.
export const registeredMinutes = (workRelation: IWorkRelationWithTimesheet): number =>
  workRelation.timesheet?.paidMinutesSum ?? 0;

// Work relations with registered hours first, the rest after, each group in
// the order they came in.
export const sortByRegisteredHours = <T extends IWorkRelationWithTimesheet>(workRelations: T[]): T[] =>
  [ ...workRelations ].sort((a, b) =>
    Number(registeredMinutes(b) > 0) - Number(registeredMinutes(a) > 0),
  );

// Same HH:MM notation as the sum row of the sheet.
export const formatRegisteredHours = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${`${hours}`.padStart(2, '0')}:${`${mins}`.padStart(2, '0')}`;
};
